import DrawingsGrid from './DrawingsGrid';

export default DrawingsGrid 


// WEBPACK FOOTER //
// ./src/components/grids/DrawingsGrid/index.jsx